import { apiCall } from "./client";

export function getAdminGuestRiders(season) {
  const params = new URLSearchParams();
  if (season != null) params.set("season", String(season));
  const qs = params.toString();
  return apiCall(`/api/admin/guest-riders${qs ? `?${qs}` : ""}`);
}

export function upsertAdminGuestRider(payload) {
  return apiCall("/api/admin/guest-riders", {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export function deleteAdminGuestRider(assignmentId) {
  return apiCall(`/api/admin/guest-riders/${assignmentId}`, {
    method: "DELETE",
  });
}

export function getSeedStatus(season) {
  const params = new URLSearchParams();
  if (season != null) params.set("season", String(season));
  const qs = params.toString();
  return apiCall(`/api/admin/seed/status${qs ? `?${qs}` : ""}`);
}

export function runSeasonSeed(season) {
  const params = new URLSearchParams();
  if (season != null) params.set("season", String(season));
  const qs = params.toString();
  return apiCall(`/api/admin/seed${qs ? `?${qs}` : ""}`, {
    method: "POST",
  });
}

export function cleanupRiderReserveFlags(season) {
  const params = new URLSearchParams();
  if (season != null) params.set("season", String(season));
  const qs = params.toString();
  return apiCall(`/api/admin/cleanup-rider-reserve-flags${qs ? `?${qs}` : ""}`, {
    method: "POST",
  });
}

export function cleanupRiderLineupNos(season) {
  const params = new URLSearchParams();
  if (season != null) params.set("season", String(season));
  const qs = params.toString();
  return apiCall(`/api/admin/cleanup-rider-lineup-nos${qs ? `?${qs}` : ""}`, {
    method: "POST",
  });
}

export function cleanupRiderNumbers(season) {
  const params = new URLSearchParams();
  if (season != null) params.set("season", String(season));
  const qs = params.toString();
  return apiCall(`/api/admin/cleanup-rider-numbers${qs ? `?${qs}` : ""}`, {
    method: "POST",
  });
}
